import { ApiResult } from "../models/ApiResult";
import { ConversationAddChatGroupDTO, ConversationAddDTO, ConversationAssignmentsReadDTO, ConversationAssignmentsWriteDTO, ConversationGroupFiltersDTO, ConversationMessageWriteDTO, ConversationParticipant, ConversationReadDTO } from "../models/Conversation";
import { ContractExtraDTO } from "../models/Profile";
import { IApiCrudRequest, IUrlAction } from "./interfaces";
import { ApiCrudRequest, apiMethode, ApiNotifictionRequest, ApiRESTRequest } from "./makeRequest";



const url: IUrlAction = {
    Get: "conversations"
}

const config: IApiCrudRequest = {
    url: url
}

class ConversationsRequest extends ApiNotifictionRequest<ConversationReadDTO> {
    constructor(config: IApiCrudRequest, token: string | undefined) {
        super(config, token);
    }

    GetAllAsAdmin(showArchived: boolean, profileId: number | null = null): Promise<ConversationReadDTO[]> {
        let obj = {
            archived: showArchived,
            profileId
        }
        return this.makeRequest<ConversationReadDTO[]>(this.CombinePath(["all"]) + "?" + this.encodeQueryData(obj), apiMethode.GET, null);
    }

    GetAllFiltered(showArchived: boolean, profileId: number | null = null): Promise<ConversationReadDTO[]> {
        let obj = {
            archived: showArchived,
            profileId: profileId
        }
        let url = this.CombinePath(["my"]);
        url = url + '?' + this.encodeQueryData(obj);
        return this.makeRequest<ConversationReadDTO[]>(url, apiMethode.GET, null);
    }

    ConversationAssignments(conversationId:number):Promise<ConversationAssignmentsReadDTO[]> {
        let url = this.CombinePath([conversationId.toString(), "assignments"]);
        return this.makeRequest<ConversationAssignmentsReadDTO[]>(url, apiMethode.GET, null);
    }

    AddProfileToConversation(conversationId: number, profileId: number, profileName: string): Promise<ApiResult> {
        let assignment: ConversationParticipant = {
            ProfileId: profileId,
            ParticipantName: profileName
        } as ConversationParticipant;
        let url = this.CombinePath([conversationId.toString(), "assignments"]);
        return this.makeRequest<ApiResult>(url, apiMethode.POST, assignment);
    }
    AddUserIdToConversation(conversationId: number, userId: string, userName: string): Promise<ApiResult> {
        let assignment: ConversationParticipant = {
            UserId: userId,
            ParticipantName: userName
        } as ConversationParticipant;
        let url = this.CombinePath([conversationId.toString(), "assignments"]);
        return this.makeRequest<ApiResult>(url, apiMethode.POST, assignment);
    }
    RemoveMemberFromConversation(conversationId: number, assingmentId: number): Promise<ApiResult> {
        let url = this.CombinePath([conversationId.toString(), "assignments", assingmentId.toString()]);
        return this.makeRequest<ApiResult>(url, apiMethode.DELETE, null);
    }
    GetAssignments(conversationId: number): Promise<ContractExtraDTO[]> {
        let url = this.CombinePath([conversationId.toString(), "assignments"]);
        return this.makeRequest<ContractExtraDTO[]>(url, apiMethode.GET, null);
    }
    AddConversation(conversation: ConversationAddDTO): Promise<ApiResult> {
        let url = this.CombinePath([]);
        return this.makeRequest<ApiResult>(url, apiMethode.POST, conversation);
    }
    AddConversationWithParticipants(conversation: ConversationAddChatGroupDTO): Promise<ApiResult> {
        let url = this.CombinePath(['group']);
        return this.makeRequest<ApiResult>(url, apiMethode.POST, conversation);
    }

    /**
     * add a new message to the conversation
     * @param newMsg 
     * @returns apiResult with n of errors and messages
     */
    AddMessage(newMsg: ConversationMessageWriteDTO): Promise<ApiResult> {
        let url = this.CombinePath([newMsg.ConversationId.toString()]);
        return this.makeRequest<ApiResult>(url, apiMethode.POST, newMsg);
    }

    /**
     * mark the message as read
     * @param msgId 
     * @returns 
     */
    MessageMarkAsRead(msgId: number): Promise<ApiResult> {
        let url = this.CombinePath(['message', msgId.toString(), 'read']);
        return this.makeRequest(url, apiMethode.POST, null);
    }

    MarkAsArchive(conversationId: number): Promise<ApiResult> {
        let url = this.CombinePath([conversationId.toString(), "archive"])
        return this.makeRequest(url, apiMethode.POST, null);
    }

    /**
     * update the live-membership criteria (profile tag / work department) of a chat group
     * @param conversationId
     * @param filters
     */
    UpdateGroupFilters(conversationId: number, filters: ConversationGroupFiltersDTO): Promise<ApiResult> {
        let url = this.CombinePath([conversationId.toString(), "filters"]);
        return this.makeRequest<ApiResult>(url, apiMethode.PUT, filters);
    }

    GetMyUnreadCount(): Promise<number> {
        let url = this.CombinePath(["my", "unread-count"]);
        return this.makeRequest<number>(url, apiMethode.GET, null);
    }

}

const conversationsRequest = (token: string | undefined) => new ConversationsRequest(config, token);
export default conversationsRequest;